import CrudPage from '@modules/cruds/CrudPage';
import { z } from 'zod';
import GroupTemplateForm from './GroupTemplateForm';
import { defaultConfigComponent } from './GroupTemplates';
import { normalizeCGroupTemplateOptions } from './normalizers/GroupTemplate.normalizers';

const zodValidationSchema = z.object({
  name: z.string(),
});

const GroupTemplatePage = props => {
  return (
    <CrudPage
      key={'groupTemplatePage'}
      configComponent={defaultConfigComponent}
      form={GroupTemplateForm}
      normalize={normalizeCGroupTemplateOptions}
      //validationSchema={validationSchema}
      zodValidationSchema={zodValidationSchema}
      methodCRUD="put"
    />
  );
};

export default GroupTemplatePage;
